import React from "react";
import { useState, useEffect } from "react";
import Navbar from "../../components/NavBar/Navbar";
import Footer from "../../components/Footer/Footer";
import headerdesign from "../../images/header design.svg";
import careerimg from "../../images/Career/career img.svg";
import "./career.css";
import Recaptcha from "react-recaptcha";
import CreateWhatsappChatWidget from "../../components/WhatsAppIcon";
import ScrollTop from "../../components/ScrollToTop/ScrollTop";
import S3 from "aws-s3";
window.Buffer = window.Buffer || require("buffer").Buffer;

function Career() {
  const listenScrollEvent = () => {
    window.scrollY > 100
      ? (document.getElementById("return-to-top").style.display = "grid")
      : // setnavColor("#252734")
        (document.getElementById("return-to-top").style.display = "none");
  };
  useEffect(() => {
    window.addEventListener("scroll", listenScrollEvent);
    return () => {
      window.removeEventListener("scroll", listenScrollEvent);
    };
  }, []);

  var url =
    "https://wati-integration-service.clare.ai/ShopifyWidget/shopifyWidget.js?3023";
  var s = document.createElement("script");
  s.type = "text/javascript";
  s.async = true;
  s.src = url;
  var options = {
    enabled: true,
    chatButtonSetting: {
      backgroundColor: "#4dc247",
      ctaText: "",
      borderRadius: "25",
      marginLeft: "0",
      marginBottom: "50",
      marginRight: "50",
      position: "right",
    },
    brandSetting: {
      brandName: "SKYLARK",
      brandSubTitle: "Typically replies within a day",
      brandImg:
        "https://skylark-website-images.s3.ap-south-1.amazonaws.com/logo_res.png",
      welcomeText: "Hi there!\nHow can I help you?",
      messageText:
        "Hello team SKYLARK, I want to pursue my career as an event manager.\n Please help me with that.\n Also, can I get all the details of institute/freelancing/internship?",
      backgroundColor: "#8e0405",
      ctaText: "Start Chat",
      borderRadius: "25",
      autoShow: false,
      phoneNumber: "916201811075",
    },
  };
  s.onload = function () {
    CreateWhatsappChatWidget(options);
  };
  var x = document.getElementsByTagName("script")[0];
  x.parentNode.insertBefore(s, x);

  const config = {
    bucketName: "skylark-website-images",
    dirName: "resumes" /* optional */,
    region: "ap-south-1",
    accessKeyId: "AKIAYNZ7DKVNNRGBZVFH",
    secretAccessKey: "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",
  };

  const S3Client = new S3(config);

  const [inputs, setInputs] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNum: null,
    WhatsAppNumber: "",
    jobNature: "",
    otherInterests: "",
    comments: "",
    resume: null,
  });

  const [file, setFile] = useState();

  const [fileUrl, setFileUrl] = useState();

  const [confirm, setConfirm] = useState();

  const [others, setOthers] = useState(false);

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
    console.log(inputs);
  };

  const handleFile = (event) => {
    setFile(event.target.files[0]);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    S3Client.uploadFile(file)
      .then((data) => {
        setFileUrl(data.location);
        const obj = inputs;
        obj.resume = data.location;

        fetch("/careers", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(obj),
        })
          .then((res) => res.json())
          .then((res) => setConfirm(res));
      })
      .catch((err) => console.error(err));
  };

  const recaptchaOnload = (value) => {
    console.log("ReCaptcha loaded");
  };

  const [verified, setVerified] = useState(false);

  const recaptchaVerifyCallback = (response) => {
    if (response) {
      console.log("ReCaptcha verified");
      setVerified(true);
    }
  };

  return (
    <div className="page_container career_container">
      <div className="career_page_header">
        <Navbar />
        <ScrollTop />

        <div className="pages_header_content">
          <p className="career_header_text">Career With Us</p>

          <img className="header_design" src={headerdesign} />
        </div>
      </div>

      <div className="career_page_cont">
        <div className="career_apply_form">
          <p className="form_heading">
            {" "}
            <span style={{ borderBottom: "2px solid #000" }}>APPLY</span> HERE
          </p>

          {!confirm ? (
            <form onSubmit={handleSubmit}>
              <div className="contact_form_names">
                <div className="contact_form_label_input">
                  <label className="contact_form_label" for="firstname">
                    First Name
                  </label>
                  <input
                    type="text"
                    id="firstname"
                    required
                    placeholder="Enter Your First Name"
                    className="contact_form_input"
                    onChange={handleChange}
                    name="firstName"
                    value={inputs.firstName || ""}
                  />
                </div>

                <div className="contact_form_label_input">
                  <label className="contact_form_label" for="lastname">
                    Last Name
                  </label>
                  <input
                    type="text"
                    id="lastname"
                    required
                    placeholder="Enter Your Last Name"
                    className="contact_form_input"
                    onChange={handleChange}
                    name="lastName"
                    value={inputs.lastName || ""}
                  />
                </div>
              </div>

              <div className="contact_form_details">
                <div className="contact_form_label_input">
                  <label className="contact_form_label" for="email">
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    required
                    placeholder="Enter Your Email"
                    className="contact_form_input"
                    onChange={handleChange}
                    name="email"
                    value={inputs.email || ""}
                  />
                </div>

                <div className="contact_form_label_input">
                  <label className="contact_form_label" for="phoneno">
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    id="phoneno"
                    required
                    placeholder="Enter Your Phone Number"
                    className="contact_form_input"
                    onChange={handleChange}
                    name="phoneNum"
                    value={inputs.phoneNum || ""}
                    minLength="10"
                  />
                </div>
              </div>

              <div
                className="contact_form_label_input"
                style={{ marginBottom: "30px" }}
              >
                <label className="contact_form_label" htmlFor="WhatsAppNumber">
                  WhatsApp Number
                </label>
                <input
                  type="tel"
                  id="WhatsAppNumber"
                  required
                  placeholder="Enter Your WhatsApp Number"
                  className="contact_form_input"
                  onChange={handleChange}
                  name="WhatsAppNumber"
                  value={inputs.WhatsAppNumber || ""}
                />
              </div>

              <label className="contact_form_label" for="jobformnature">
                Your Interest
              </label>

              <div id="jobformnature">
                <div>
                  <input
                    name="jobNature"
                    onChange={handleChange}
                    id="freelancing"
                    required
                    onClick={() => setOthers(false)}
                    type="radio"
                    value="freelancing"
                  />
                  <label
                    htmlFor="freelancing"
                    style={{ opacity: "0.7" }}
                    className="contact_form_label"
                  >
                    Freelancing
                  </label>
                </div>

                <div>
                  <input
                    name="jobNature"
                    onChange={handleChange}
                    id="Intern"
                    onClick={() => setOthers(false)}
                    type="radio"
                    value="Intern"
                  />
                  <label
                    htmlFor="Intern"
                    style={{ opacity: "0.7" }}
                    className="contact_form_label"
                  >
                    Internship
                  </label>
                </div>

                <div>
                  <input
                    name="jobNature"
                    onChange={handleChange}
                    id="Diploma"
                    type="radio"
                    onClick={() => setOthers(false)}
                    value="Diploma/PGDM"
                  />
                  <label
                    htmlFor="Diploma"
                    style={{ opacity: "0.7" }}
                    className="contact_form_label"
                  >
                    Diploma/ PGDM Course Enquiry
                  </label>
                </div>

                <div>
                  <input
                    name="jobNature"
                    onChange={(e) => {
                      handleChange(e);
                      setOthers(true);
                      setInputs((values) => {
                        return {
                          ...values,
                          jobNature: "",
                        };
                      });
                    }}
                    onClick={() => setOthers(true)}
                    id="others"
                    type="radio"
                    value="Others"
                  />
                  <label
                    htmlFor="others"
                    style={{ opacity: "0.7" }}
                    className="contact_form_label"
                  >
                    Others
                  </label>
                </div>
              </div>

              {others ? (
                <div
                  style={{ marginTop: "20px" }}
                  className="contact_form_label_input"
                >
                  <label className="contact_form_label" for="comment">
                    Others
                  </label>
                  <input
                    type="text"
                    id="otherInterests"
                    placeholder="Mention your interest"
                    className="contact_form_input"
                    onChange={handleChange}
                    name="jobNature"
                    value={inputs.jobNature || ""}
                    required
                  />
                </div>
              ) : null}

              <div
                style={{ marginTop: "20px", marginBottom: "30px" }}
                className="contact_form_label_input"
              >
                <label className="contact_form_label" for="comment">
                  Comments
                </label>
                <input
                  type="text"
                  id="comments"
                  placeholder="Any Comments"
                  className="contact_form_input"
                  onChange={handleChange}
                  name="comments"
                  value={inputs.comments || ""}
                />
              </div>

              <div
                style={{
                  display: "grid",
                  gridGap: "10px",
                  justifyContent: "flex-start",
                  marginTop: "20px",
                }}
              >
                <label className="contact_form_label" for="resume">
                  Upload your Resume
                </label>
                <input
                  id="resume"
                  type="file"
                  required
                  className="resume_upload"
                  name="resume"
                  onChange={handleFile}
                />

                <Recaptcha
                  sitekey="6LfcsDshAAAAAPiHFqN6mc0_PbD0Eatcw04AP-k_"
                  render="explicit"
                  verifyCallback={recaptchaVerifyCallback}
                  onloadCallback={recaptchaOnload}
                />

                <button
                  style={
                    !verified
                      ? {
                          background: "rgba(142, 4, 5, 0.3)",
                          color: "#fff",
                          cursor: "default",
                        }
                      : null
                  }
                  type="submit"
                  className="send_btn"
                >
                  Send
                </button>
              </div>
            </form>
          ) : (
            <div className="career_form_confirm">
              <svg
                style={{
                  width: "40px",
                  height: "40px",
                  margin: "auto",
                }}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="green"
              >
                <path
                  fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clip-rule="evenodd"
                ></path>
              </svg>{" "}
              <p>Your response has been recorded</p>
              <p>We'll get back to you soon</p>
            </div>
          )}
        </div>

        <div className="career_right_cont">
          <p className="career_text1">
            Seeking Opportunity in Event Management ?
          </p>
          <p style={{ marginTop: "10px" }} className="career_text2">
            You are at the right place to start. Just fill the form and grab the
            opportunity!
          </p>

          <img className="career_image" src={careerimg} />

          <p style={{ marginTop: "7px" }} className="career_text4">
            Explore The Opportunity !!
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Career;
